module.exports = __webpack_public_path__ + "img/shengchanchejian.1f003209.png";